import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewEncapsulation
} from "@angular/core";
import { ADPResourceService as ResourceService } from "digital-core";


@Component({
  selector: "branch-header",
  templateUrl: "./branch-header.component.html",
  styleUrls: ["./branch-header.component.css"],
  encapsulation: ViewEncapsulation.None
})
export class BranchHeaderComponent implements OnInit {
  @Input() isBranchEditable: boolean;
  @Input() branchName: string;
  @Input() isDividerRequired:boolean=true;
  @Output() changeBranch: EventEmitter<boolean> = new EventEmitter<boolean>(false);

  branchHeader: string = "Branch";

  constructor(public resourceService: ResourceService) { }

  ngOnInit() {
    this.branchHeader = this.resourceService.getViewLabel("Global_Text_BranchHeaderText");
  }

  branchChange() {
    this.changeBranch.emit(true);
  }

}
